export const CONVERSIONS_PAGE_SIZE = 25;

export const SCHEDULE_DATE_RANGE_OPTIONS = [7, 14, 28];

export const CHANGELOG_ENTRIES = [
  { date: "2025-03-10", change: "Updated Q1 campaign budget from $12k to $15k", author: "Jordan Smith" },
  { date: "2025-03-09", change: "Added new creative variant 'Spring Promo' to Brand Campaign", author: "Alex Chen" },
  { date: "2025-03-08", change: "Paused underperforming podcast 'Tech Daily' in Conversion Pods", author: "Jordan Smith" },
  { date: "2025-03-07", change: "Changed attribution window from 7-day to 14-day for reporting", author: "Sam Rivera" },
  { date: "2025-03-06", change: "Duplicated March campaign settings to create April baseline", author: "Alex Chen" },
  { date: "2025-03-05", change: "Updated target CPA from $45 to $42 for Brand Campaign", author: "Jordan Smith" },
];
